module.exports = __webpack_public_path__ + "static/media/mobile.c3838c36.svg";